export const STATUS_COLS = [
  { key: "planifiee", label: "Planifiée", cls: "border-t-neutral-400" },
  { key: "en_cours", label: "En cours", cls: "border-t-amber-500" },
  { key: "terminee", label: "Terminée", cls: "border-t-emerald-500" },
];
export const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
export const UNASSIGNED = "__none__";

const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const mondayOf = (d) => {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x;
};
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const weekDays = (monday) => DAYS.map((label, i) => ({ key: ymd(addDays(monday, i)), label, date: addDays(monday, i) }));

export const collabKeys = (it) => {
  const c = it.collaborateurs || [];
  return c.length ? c.map((x) => x.login || x.nom) : [UNASSIGNED];
};

export const filterItems = (items, { period, easer, client, monday, service }) => {
  const today = ymd(new Date());
  const wk0 = ymd(monday), wk1 = ymd(addDays(monday, 6));
  const q = (client || "").trim().toLowerCase();
  return items.filter((it) => {
    const d = (it.date || "").slice(0, 10);
    if (period === "week" && (d < wk0 || d > wk1)) return false;
    if (period === "upcoming" && d < today) return false;
    if (easer && !collabKeys(it).includes(easer)) return false;
    if (service && (it.service || "clean") !== service) return false;
    if (q && !`${it.client_nom} ${it.adresse || ""} ${it.ville || ""}`.toLowerCase().includes(q)) return false;
    return true;
  });
};

export const groupItems = (items, mode, team, monday) => {
  if (mode === "status") return STATUS_COLS.map((c) => ({ ...c, items: items.filter((it) => (it.status || "planifiee") === c.key) }));
  if (mode === "day") {
    const wk0 = ymd(monday), wk1 = ymd(addDays(monday, 6));
    const inWeek = items.filter((it) => { const d = (it.date || "").slice(0, 10); return d >= wk0 && d <= wk1; });
    return weekDays(monday).map((d) => ({ key: d.key, label: d.label, sub: d.date.toLocaleDateString("fr-FR", { day: "numeric", month: "short" }), cls: "border-t-brand",
      items: inWeek.filter((it) => (it.date || "").slice(0, 10) === d.key).sort((a, b) => a.date.localeCompare(b.date)) }));
  }
  const cols = team.map((t) => ({ key: t.login || t.nom, label: t.nom, sub: t.level === "major" ? "Major" : "Easer", cls: "border-t-brand",
    items: items.filter((it) => collabKeys(it).includes(t.login || t.nom)) }));
  cols.push({ key: UNASSIGNED, label: "Non affecté", cls: "border-t-red-500", items: items.filter((it) => collabKeys(it).includes(UNASSIGNED)) });
  return cols;
};
